import apiService from "./apiService";

// === CONTACT US MESSAGES ===
const getAllCustomersContactUsForm = () => {
  return apiService.getAll("backend/contact-messages");
};

const useContactUsService = {
  getAllCustomersContactUsForm,
};

export default useContactUsService;
